module.exports = __webpack_public_path__ + "static/media/Full video Website Vertical (fine).23b566dc.mp4";